export const appElement = (app: AppType) => document.getElementById(app) as HTMLCanvasElement | HTMLDivElement

export enum AppType {
    PHASER = "phaser-app",
    BABYLON = "babylon-app",
    REACT = "react-app"
}
